import React from 'react'
import { styled } from 'styletron-react'
import { padding, margin } from 'lostyle'
import { media, sizes } from '../../style'

const Img = styled('img', {
  maxWidth: `calc(100% + (${sizes.spacing.gutter.mobile} * 2))`,
  display: 'block',
  ...padding('0'),
  ...margin({ x: `-${sizes.spacing.gutter.mobile}` }),
  ...media('tabletLandscape', {
    maxWidth: '100%',
    ...margin({ x: '0' })
  })
})
Img.displayName = 'Img'

export default Img


// WEBPACK FOOTER //
// ./src/components/Img/index.js